import styled, { css } from 'styled-components';
import { Z_INDEX_DEFAULT } from '../../../../constants/z_index';
import { useUnseenCountText } from './useUnseenCountText';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Container = styled.div.withConfig({
  displayName: "UnseenIndicator__Container",
  componentId: "sc-1ip82z7-0"
})(["position:relative;display:flex;height:100%;"]);
const Indicator = styled.span.withConfig({
  displayName: "UnseenIndicator__Indicator",
  componentId: "sc-1ip82z7-1"
})(({
  theme: _theme
}) => {
  const theme = _theme;
  return css(["display:flex !important;justify-content:center;align-items:center;min-width:14px !important;min-height:14px !important;position:absolute;background-color:", ";color:", " !important;pointer-events:none;border-radius:14px;bottom:50%;left:50%;font-size:11px !important;line-height:11px !important;padding:0 4px !important;font-weight:400 !important;text-wrap:nowrap;z-index:", ";"], theme.color['icon-alert-pressed'], theme.color['text-alert-on-fill-default'], Z_INDEX_DEFAULT);
});
export const UnseenIndicator = ({
  children
}) => {
  const {
    unseenCountText
  } = useUnseenCountText();
  return /*#__PURE__*/_jsxs(Container, {
    children: [children, unseenCountText ? /*#__PURE__*/_jsx(Indicator, {
      "data-test-id": "unseen-notifications-count",
      children: unseenCountText
    }) : null]
  });
};